import { effectFilters, rarityGlows } from '../constants/effects';
import { FISH_SPRITE_HEIGHTS, DEFAULT_DIRECTORY_SPRITE_HEIGHT } from '../constants/assets';

const ALL_VARIANTS = ['shiny', 'neon', 'ethereal', 'prismatic', 'golden'];
const ALL_RARITIES = ['common', 'uncommon', 'rare', 'special', 'legendary', 'mythical'];

export default function DirectoryDetailCard({ fish, entry, onClose }) {
  if (!fish || !entry) return null;

  const spriteHeight = FISH_SPRITE_HEIGHTS[fish.id] ?? DEFAULT_DIRECTORY_SPRITE_HEIGHT;

  const discoveredDate = new Date(entry.discoveredAt).toLocaleDateString('en-US', {
    month: '2-digit', day: '2-digit', year: '2-digit',
  });

  const validVariants = ALL_VARIANTS.filter(v => fish.effects.includes(v));
  const validRarities = ALL_RARITIES.filter(r => fish.rarities.includes(r));
  const topRarity     = fish.rarities[fish.rarities.length - 1];
  const glowColor     = rarityGlows[topRarity] || '#ffffff';

  return (
    <div style={{
      position: 'fixed', inset: 0, backgroundColor: '#05070a',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', zIndex: 200, padding: '20px',
      overflowY: 'auto',
    }}>

      {/* Fish Sprite */}
      <div
        key={fish.id} 
        style={{ filter: `drop-shadow(0 0 20px ${glowColor})` }}>
        <img
          src={`assets/fish/${fish.id}.png`}
          alt={fish.name}
          style={{
            width: 'auto',
            height: `${spriteHeight}px`,
            objectFit: 'contain',
            imageRendering: 'pixelated',
            filter: effectFilters['default'],
          }}
          onError={(e) => { e.target.src = 'https://via.placeholder.com/100?text=FISH'; }}
        />
      </div>

      {/* Name */}
      <h2 style={{
        color: glowColor, fontSize: '20px', margin: '20px 0 4px',
        textTransform: 'uppercase', textAlign: 'center',
        textShadow: `0 0 10px ${glowColor}`,
      }}>
        {fish.name}
      </h2>

      {/* Tier badge */}
      <span style={{ color: '#8b949e', fontSize: '8px', letterSpacing: '2px', marginBottom: '20px' }}>
        {fish.tier} TIER
      </span>

      {/* Personal Records */}
      <div style={{
        display: 'flex', flexDirection: 'column', gap: '10px',
        backgroundColor: '#161b22', padding: '15px 25px',
        borderRadius: '8px', border: '1px solid #30363d',
        width: '100%', maxWidth: '280px',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#8b949e', fontSize: '9px' }}>MAX WEIGHT</span>
          <span style={{ color: '#ffffff', fontSize: '9px' }}>{entry.maxWeight} lbs</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#8b949e', fontSize: '9px' }}>MAX VALUE</span>
          <span style={{ color: '#44ff44', fontSize: '9px' }}>{entry.maxGoldValue} gold</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#8b949e', fontSize: '9px' }}>FIRST CAUGHT</span>
          <span style={{ color: '#ffffff', fontSize: '9px' }}>{discoveredDate}</span>
        </div>
      </div>

      {/* Rarities */}
      <div style={{ marginTop: '20px', width: '100%', maxWidth: '280px' }}>
        <p style={{ color: '#8b949e', fontSize: '8px', letterSpacing: '2px', marginBottom: '10px', textAlign: 'center' }}>
          RARITIES CAUGHT
        </p>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {validRarities.map(rarity => {
            const seen  = entry.raritiesSeen?.includes(rarity);
            const color = rarityGlows[rarity] || '#ffffff';
            return (
              <span
                key={rarity}
                style={{
                  padding: '6px 10px', borderRadius: '4px',
                  fontSize: '8px', textTransform: 'uppercase', letterSpacing: '1px',
                  border: seen ? `1px solid ${color}` : '1px solid #30363d',
                  color: seen ? color : '#30363d',
                  backgroundColor: seen ? `${color}15` : 'transparent',
                }}
              >
                {seen ? '✓' : '?'} {rarity}
              </span>
            );
          })}
        </div>
      </div>

      {/* Variants */}
      {validVariants.length > 0 && (
        <div style={{ marginTop: '20px', width: '100%', maxWidth: '280px' }}>
          <p style={{ color: '#8b949e', fontSize: '8px', letterSpacing: '2px', marginBottom: '10px', textAlign: 'center' }}>
            VARIANTS SEEN
          </p>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            {validVariants.map(variant => {
              const seen = entry.variantsSeen.includes(variant);
              return (
                <span
                  key={variant}
                  style={{
                    padding: '6px 10px', borderRadius: '4px',
                    fontSize: '8px', textTransform: 'uppercase', letterSpacing: '1px',
                    border: seen ? '1px solid #f1c40f' : '1px solid #30363d',
                    color: seen ? '#f1c40f' : '#30363d',
                    backgroundColor: seen ? 'rgba(241,196,15,0.08)' : 'transparent',
                  }}
                >
                  {seen ? '✓' : '?'} {variant}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* Close */}
      <button
        onClick={onClose}
        style={{
          marginTop: '30px', padding: '12px 32px',
          backgroundColor: 'transparent', color: '#8b949e',
          border: '1px solid #30363d', borderRadius: '6px',
          cursor: 'pointer', fontFamily: 'inherit', fontSize: '10px',
        }}
      >
        CLOSE
      </button>

    </div>
  );
}